import { BigNumber } from 'ethers';
import * as plugins from '../../../Fct/pluginsExport';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var Erc20Approvals = createMulticallPlugin({
    plugin: plugins.ERC20.actions.Approve,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY',
    method: 'erc20Approvals',
    name: 'erc20Approvals',
    config: {
        params: [
            { key: 'to', multicallKey: 'token' },
            { key: 'methodParams.spender', multicallKey: 'spender' },
            { key: 'methodParams.amount', multicallKey: 'amount' },
        ],
    },
    estimateGasFromPlugins: function (plugins, chainId) {
        // Gas notes:
        // 1 approve = 34000 gas
        var gas = BigNumber.from(plugins.length).mul(34000);
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
});
